<template>
    <div id="app">
        <router-view />
    </div>
</template>
<script>
import Core from 'core';
import { mapMutations } from 'vuex';
import * as types from './store/mutation-types';

export default {
    created() {
        this.checkLoginStatus();
    },
    methods: {
        ...mapMutations({
            setUser: types.SET_USER
        }),
        checkLoginStatus() {
            const token = Core.Data.getToken();
            if (token) {
                Core.Api.User.detail().then(res => {
                    this.setUser(res.user)
                })
            }
        }
    }
};
</script>
<style lang="scss">
#app {
    @import './common/styles/normalize.scss';
    @import './common/styles/reset.scss';
    @import './common/styles/common.scss';
    #app {
        font-size: $font-size-base;
        color: $color-common;
        font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
    }
}
</style>
